import { useState, useEffect, useRef } from "react";
import Dropdown from "./dropdown";
import styles from "./styles.module.css";

export default function Pill({
  value,
  type,
  list,
  sources,
  onChange,
  onDelete,
}) {
  const [position, setPosition] = useState(null);
  const [lastValue, setLastValue] = useState({ type: "", list: false });
  const pill = useRef();

  const _setPosition = () => {
    const v = pill.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const leftOffset = 600 - v.left > 0 ? 600 - v.left : 0;
    setPosition({
      x: windowWidth - v.right - leftOffset,
      y: v.bottom + 10,
      height: windowHeight - v.bottom - 30,
    });
  };

  const handleDelete = (...args) => {
    setPosition(null);
    onDelete(...args);
  };

  useEffect(() => {
    const index = Object.keys(value).length - 1;
    if (value[index]) {
      setLastValue({
        type: value[index].returnType,
        list: value[index].returnList,
      });
    }
  }, [value]);

  useEffect(() => {
    if (position) {
      _setPosition();
    }
  }, [value]);
  return (
    <div
      className={
        lastValue.type === type && lastValue.list === list
          ? `${styles.pill} ${styles.correct}`
          : styles.pill
      }
      contentEditable={false}
    >
      <span ref={pill} onClick={_setPosition}>
        {typeof value === "object" && Object.keys(value).length > 0
          ? Object.keys(value)
              .map(
                (k) =>
                  `${value[k].name}${
                    Object.keys(value[k].props).length > 0 ? "(...)" : ""
                  }`
              )
              .join("-")
          : "select..."}
      </span>
      <Dropdown
        position={position}
        type={type}
        list={list}
        value={value}
        extraSources={sources}
        onDelete={handleDelete}
        onClose={() => setPosition(null)}
        onChange={(v) => onChange(v)}
      />
    </div>
  );
}
